var map = {
	"./asset-hyperlink.json": 1088,
	"./blockquote.json": 9628,
	"./document.json": 1818,
	"./embedded-asset-block.json": 351,
	"./embedded-entry-block.json": 641,
	"./embedded-entry-inline.json": 9600,
	"./embedded-resource-block.json": 8437,
	"./embedded-resource-inline.json": 283,
	"./entry-hyperlink.json": 8204,
	"./heading-1.json": 4396,
	"./heading-2.json": 3015,
	"./heading-3.json": 7154,
	"./heading-4.json": 7982,
	"./heading-5.json": 6999,
	"./heading-6.json": 1776,
	"./hr.json": 7047,
	"./hyperlink.json": 2913,
	"./list-item.json": 8209,
	"./ordered-list.json": 9119,
	"./paragraph.json": 9530,
	"./resource-hyperlink.json": 3582,
	"./table-cell.json": 1601,
	"./table-header-cell.json": 7320,
	"./table-row.json": 6409,
	"./table.json": 1315,
	"./text.json": 1612,
	"./unordered-list.json": 3596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;